import { Modal } from "bootstrap";
import { Component, Shark, Utils } from "shark-mvc";

import templateContent from "./organization-user-detail-panel.html";

import organizationMembershipManager from "../../managers/organizationMembershipManager";
import waitBoxComponent from "../waitBox/waitBoxComponent";

class OrganizationUserDetailPanelComponent extends Component {
	constructor () {
		super("organizationUserDetailPanelComponent");

		this.addTemplate("", templateContent);
	}

	afterLoad () {
		const modalNode = document.querySelector("#organizationUserDetailModal");
		
		if (modalNode) {
			this.modal = new Modal(modalNode);
		}
	}

	close () {
		Shark.$store.__isEditingOrganizationUser = false;

		if (this.modal) {
			this.modal.hide();
		}
	}

	async deleteMembership (organizationMembership) {
		waitBoxComponent.open();
		let success = false;
		const deleteResult = await organizationMembershipManager.delete(organizationMembership);
		// console.log({deleteResult});

		if (deleteResult.data.rc === 1) {
			success = true;
			// await this.refreshList();
			this.emit("userListRefreshNeeded");
		}
		waitBoxComponent.close();
		return success;
	}
	
	deleteMembershipBtn_clickHandler () {
		const { currOrganizationUser } = Shark.get();

		if (currOrganizationUser && confirm(`Vuoi davvero eliminare l'invito per ${currOrganizationUser.inviteEMail}?`)) {
			if (this.deleteMembership(currOrganizationUser)) {
				this.close();
			}
		}
	}

	editOrganizationUserBtn_clickHandler (event, data) {
		const currOrganizationUser = Utils.safp(Shark.$store.organizationMembershipList, "guid", data.guid);
		
		if (currOrganizationUser) {
			Shark.set({
				currOrganizationUser,
			});

			Shark.render();
			this.open();
		}
	}

	init () {
		this.addComponents([waitBoxComponent]);

		Shark.set({
			__isEditingOrganizationUser: false,
		});
	}

	open () {
		if (this.modal) {
			this.modal.show();
		}		
	}

	organizationUserDetailPanelinviteName_changeHandler () {
		const { currOrganizationUser } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="inviteName"]`).forEach(item => currOrganizationUser.validateMemberName() != [] ? item.classList.remove("invalid") : item.classList.add("invalid")); 
	}

	async saveOrganizationUser (organizationUser) {
		waitBoxComponent.open();
		await organizationMembershipManager.save(organizationUser);
		this.close();
		waitBoxComponent.close();
	}

	saveOrganizationUserBtn_clickHandler () {
		const { currOrganizationUser } = Shark.get();

		if (currOrganizationUser) {
			const validationError = currOrganizationUser.validate();

			if (validationError.length > 0) {
				validationError.forEach(error => {
					document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
					setTimeout(() => {
						document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
					}, 250);
				});
			}
			else {
				this.saveOrganizationUser(currOrganizationUser);
			}
		}
	}

	toggleOrganizationUserEditing () {
		Shark.$store.__isEditingOrganizationUser = !Shark.$store.__isEditingOrganizationUser;
	}

	toggleOrganizationUserEditingBtn_clickHandler () {
		const { currOrganizationUser } = Shark.get();

		if (Shark.$store.__editingOrganizationUser && currOrganizationUser.isDirty()) {
			if (!confirm(Shark.$store.labels.warning_changes_not_saved)) {
				return;
			}
		}
		currOrganizationUser.restore();
		this.toggleOrganizationUserEditing();
	}

}

const organizationUserDetailPanelComponent = new OrganizationUserDetailPanelComponent();

Shark.registerComponent(organizationUserDetailPanelComponent);

export default organizationUserDetailPanelComponent;